export default __webpack_public_path__ + "static/TransportationSafetyPrograms-439b456b2a1af3b2e7f91edd97f02c00.jpg";